import React, { useState, useEffect } from "react";
import "../styles/EmailVerificationPopup.css";

export default function EmailVerificationPopup({ email, onClose, onSuccess }) {
  const [verificationCode, setVerificationCode] = useState("");
  const [resendTimer, setResendTimer] = useState(600); // ⏱️ 10 dakika
  const [canResend, setCanResend] = useState(false);
  const [resendSuccess, setResendSuccess] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    console.log("✅ EmailVerificationPopup DOM'a girdi.");
  }, []);

  useEffect(() => {
    const handleEnter = (e) => {
      if (e.key === "Enter") {
        handleVerify();
      }
    };

    document.addEventListener("keydown", handleEnter);
    return () => document.removeEventListener("keydown", handleEnter);
  }, [verificationCode]);

  useEffect(() => {
    const sendInitialCode = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ResendEmailCode?email=${encodeURIComponent(email)}`,
          { method: "POST" }
        );
        if (response.ok) {
          setResendSuccess("✅ Kod e-posta adresine gönderildi.");
          setTimeout(() => {
            setResendSuccess("");
          }, 3000);
        } else {
          console.warn("❌ Kod otomatik gönderilemedi.");
        }
      } catch (err) {
        console.error("⚠️ İlk kod gönderim hatası:", err);
      }
    };

    sendInitialCode();
  }, []);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    let timer;
    if (!canResend) {
      timer = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [canResend]);

  const handleVerify = async () => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ConfirmEmailWithCode?email=${encodeURIComponent(email)}&code=${verificationCode}`;
      const res = await fetch(url, { method: "POST" });
      const text = await res.text();

      try {
        const parsed = JSON.parse(text);
        if (res.ok) {
          const token = parsed.token || parsed.result || text;
          localStorage.setItem("token", token);
          localStorage.setItem("userEmail", email);
          localStorage.setItem("loginEmail", email);

          setSuccessMessage("✅ Doğrulama başarılı! Giriş ekranına yönlendiriliyorsunuz...");

          setVerificationCode("");

          setTimeout(() => {
            onSuccess?.();
            onClose();
          }, 2500);
        } else {
          setError(parsed.message || "❌ Kod hatalı veya süresi doldu.");
        }
      } catch {
        if (res.ok && text.length > 10) {
          localStorage.setItem("token", text);
          localStorage.setItem("userEmail", email);
          setSuccessMessage("✅ Doğrulama başarılı! Giriş ekranına yönlendiriliyorsunuz...");
          localStorage.setItem("loginEmail", email);
          setTimeout(() => {
            onSuccess?.();
            onClose();
          }, 2500);
        } else {
          setError("❌ Kod hatalı veya süresi doldu.");
        }
      }
    } catch (err) {
      console.error("Kod doğrulama hatası:", err);
      setError("⚠️ Doğrulama sırasında bir hata oluştu.");
    }
  };



  const handleResendCode = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ResendEmailCode?email=${encodeURIComponent(email)}`,
        { method: "POST" }
      );

      if (response.ok) {
        setResendSuccess("✅ Kod tekrar gönderildi.");
        setError("");
        setCanResend(false);
        setResendTimer(600);
      } else if (response.status === 400) {
        setError("⏳ Yeni kod için 10 dakika beklemelisin.");
        setResendSuccess("");
      } else {
        setError("❌ Kod gönderilemedi.");
        setResendSuccess("");
      }
    } catch {
      setError("⚠️ Kod gönderme sırasında bir hata oluştu.");
      setResendSuccess("");
    }
  };

  return (
    <div className="verification-overlay">
      <div className="verification-popup">
        <button className="mail-close-btn" onClick={onClose}>✖</button>
        <h3>Doğrulama Kodu</h3>
        <p><strong>{email}</strong> adresine gelen kodu giriniz:</p>

        <input
          type="text"
          value={verificationCode}
          onChange={(e) => setVerificationCode(e.target.value)}
          placeholder="Doğrulama Kodu"
          className="input-field"
        />

        {error && <p className="error-message">{error}</p>}
        {resendSuccess && <p className="success-message">{resendSuccess}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        <button onClick={handleVerify} className="verify-button">
          Kodu Doğrula
        </button>

        <button
          onClick={handleResendCode}
          className="resend-button"
          disabled={!canResend}
        >
          {canResend ? "Kodu Tekrar Gönder" : `Tekrar gönder (${formatTime(resendTimer)})`}
        </button>

      </div>
    </div>
  );
}
